import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Trainings(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Тренировки
      </Typography.Title>
      <List />
    </div>
  );
}
